(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Video-first product grid */
  (() => {
    if (window.__gridVideoFirstInit) return;
    window.__gridVideoFirstInit = true;

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

    const findMediaHost = (card) => {
      const image = card.querySelector('img');
      return (
        card.querySelector('.product-media-container') ||
        card.querySelector('.card-gallery') ||
        card.querySelector('.product-media') ||
        (image ? image.parentElement : null)
      );
    };

    const loadVideo = (video) => {
      if (video.dataset.loaded === 'true') return;
      video.src = video.dataset.src;
      video.dataset.loaded = 'true';
    };

    const playVideo = (video) => {
      loadVideo(video);
      video.classList.add('is-visible');
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(() => {});
      }
    };

    const stopVideo = (video, keepVisible) => {
      video.pause();
      if (!keepVisible) video.classList.remove('is-visible');
    };

    const viewportObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            playVideo(entry.target);
          } else {
            stopVideo(entry.target, true);
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0.2 }
    );

    const setupCard = (card) => {
      if (card.dataset.videoReady === 'true') return;
      const src = card.dataset.videoSrc;
      if (!src) return;
      card.dataset.videoReady = 'true';

      if (reducedMotion.matches) return;

      const list = card.closest('results-list');
      const mode = (list && list.getAttribute('video-play-mode')) || 'always';
      const mobileAutoplay = !list || list.getAttribute('video-mobile-autoplay') !== 'false';
      if (mobileQuery.matches && !mobileAutoplay) return;

      const host = findMediaHost(card);
      if (!host) return;

      const video = document.createElement('video');
      video.className = 'grid-video-first';
      video.dataset.src = src;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.preload = 'none';
      video.tabIndex = -1;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('aria-hidden', 'true');
      if (card.dataset.videoPoster) video.poster = card.dataset.videoPoster;
      video.addEventListener('error', () => video.remove(), { once: true });

      host.classList.add('has-grid-video');
      host.appendChild(video);

      if (mode === 'hover' && hoverCapable.matches) {
        card.addEventListener('pointerenter', () => playVideo(video));
        card.addEventListener('focusin', () => playVideo(video));
        card.addEventListener('pointerleave', () => stopVideo(video, false));
        card.addEventListener('focusout', () => stopVideo(video, false));
      } else {
        viewportObserver.observe(video);
      }
    };

    const scan = () => {
      document
        .querySelectorAll('[data-video-src]:not([data-video-ready="true"])')
        .forEach(setupCard);
    };

    let queued = false;
    const queueScan = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        scan();
      });
    };

    /* Re-scan after filtering, pagination and infinite scroll re-renders */
    const domObserver = new MutationObserver(queueScan);

    const start = () => {
      scan();
      domObserver.observe(document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
